import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import axios from 'axios';
import { API } from '../App';

const CurrentAffairsPage = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${API}/settings`);
      setSettings(response.data);
      
      if (response.data.current_affairs_redirect) {
        window.location.href = 'https://kapaatu.website';
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div>
        <Navbar />
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '5rem' }}>
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-cyan-600"></div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Navbar />
      
      <div className="page-header">
        <div className="container">
          <h1 data-testid="page-title">Current Affairs</h1>
        </div>
      </div>

      <section className="py-8 container text-center">
        <div className="card" style={{ maxWidth: '600px', margin: '0 auto' }}>
          <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🚀</div>
          <h2 style={{ marginBottom: '1rem' }}>Coming Soon</h2>
          <p style={{ color: 'var(--muted-foreground)', fontSize: '1.125rem' }}>
            We're preparing comprehensive current affairs updates for you. Stay tuned!
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CurrentAffairsPage;